@layer module {
.modal-content-surface {
            position: relative;
    }

.modal-footer {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
    }
} // layer module










@layer app {
.modal-content-surface {
            max-width: $size-500;
            border-radius: $size-20;
            padding: $size-26 $size-28;
    }

.modal-content-surface-wide {
            max-width: $size-650;
    }

.modal-subtitle {
            margin: $size-4 0 0;
            padding-right: $size-40;
    }

.modal-footer {
            gap: $size-10;
            margin-top: $size-4;
    }

.modal-content-surface {
            width: var(--modal-fill-inline-size);
            background: var(--bg-modal);
    }

.modal-subtitle {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }
} // layer app










@layer context {
      @media (min-width: 1025px) {
                :global(.maintenance-modal-wrapper).modal-content-surface {
                        padding: $size-40 $size-50;
                    }
          }
} // layer context
